<template>
  <div
    class="top-nav"
    id="download"
    v-if="extras.groupDownloadDisplay.display == 1"
    :style="{
      background:
        extras.downloadBg.colorOrBg == 'color'
          ? extras.downloadBg.color
          : 'url(' + extras.downloadBg.src + ')',
    }"
  >
    <div class="g-download-info new">
      <div class="g-download-content u-w1200">
        <Title
          v-if="extras.downloadTitle.display == 1"
          :title="extras.downloadTitle.mainTitle || title"
          :en="extras.downloadTitle.subTitle || 'DOWNLOAD'"
          :extras="extras"
        />
        <div style="position: relative; overflow: hidden" ref="downLoadTab">
          <div
            class="m-tab-list-new"
            v-if="folderList.length > 1"
            :class="'tab-length' + folderList.length"
            :style="{
              width: folderList.length < 5 ? 'auto' : '',
              display: folderList.length < 5 ? 'flex' : 'inline-block',
            }"
          >
            <div
              class="tab-new u-mr30"
              v-for="(item, index) in folderList"
              :key="index"
              :class="{
                active: item.id == currentId,
                'cursor-default': isSetting == 1,
              }"
              @click="columnClick(item)"
            >
              {{ item.name }}
              <div data-v-2a8f24dd="" class="underline"></div>
            </div>
          </div>
        </div>
        <div
          class="g-download-list-new"
          :class="extras.downloadStyle.style == '1' ? 'single' : ''"
          v-if="fileList && fileList.length > 0"
        >
          <div
            class="item"
            :style="{
              background:
                extras.downloadItemBg.colorOrBg == 'color'
                  ? extras.downloadItemBg.color
                  : 'url(' + extras.downloadItemBg.src + ')',
            }"
            v-for="(item, index) in fileList"
            :key="index"
          >
            <img
              :src="
                item.iconMapRealPath
                  ? item.iconMapRealPath
                  : require('@/assets/images/defaultNew.jpg')
              "
              alt=""
            />
            <div
              class="name"
              v-if="extras.downloadItenTitle.display == 1"
              :style="{
                color:
                  extras.downloadItenTitle.text == 'custom'
                    ? extras.downloadItenTitle.fontColor
                    : '',
                'font-size':
                  extras.downloadItenTitle.text == 'custom'
                    ? extras.downloadItenTitle.fontSize + 'px'
                    : '',
                'font-style':
                  extras.downloadItenTitle.text == 'custom'
                    ? extras.downloadItenTitle.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.downloadItenTitle.text == 'custom'
                    ? extras.downloadItenTitle.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
            >
              {{ item.name }}
            </div>
            <div
              class="button"
              v-if="extras.downloadButton.display == 1"
              @click="download(item)"
              :style="{
                width:
                  extras.downloadButton.layout == 'custom'
                    ? extras.downloadButton.btnWidth + '%'
                    : '',
                background:
                  extras.downloadButton.layout == 'custom'
                    ? extras.downloadButton.colorOrBg == 'color'
                      ? extras.downloadButton.color
                      : 'url(' + extras.downloadButton.src + ')'
                    : '',
                color:
                  extras.downloadButton.style == 'custom'
                    ? extras.downloadButton.fontColor
                    : '',
                'font-size':
                  extras.downloadButton.style == 'custom'
                    ? extras.downloadButton.fontSize + 'px'
                    : '',
                'font-style':
                  extras.downloadButton.style == 'custom'
                    ? extras.downloadButton.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.downloadButton.style == 'custom'
                    ? extras.downloadButton.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'border-width': extras.downloadButton.border == 'show' ? '' : 0,
              }"
            >
              <span
                class="icontemp download-a"
                v-if="extras.downloadButtonText.icon != 'hide'"
              ></span
              >{{ extras.downloadButtonText.text }}
            </div>
          </div>
        </div>

        <div class="m-nodata-body" v-if="fileList && fileList.length == 0">
          <img src="@/assets/images/nodata.png" />
          <div class="m-nodata">{{ $t("暂无数据") }}</div>
        </div>
      </div>
    </div>

    <vodal :show="show" animation="zoom" @hide="show = false">
      <div class="mail-box" v-if="Sent == true">
        <div class="title">请输入您的邮箱</div>
        <div class="mail">
          <input type="text" placeholder="请输入您的邮箱" v-model="mailbox" />
          <p class="tip">{{ tip }}</p>
        </div>
        <div class="btn" style="text-align: center">
          <button
            type="button"
            style="
              padding: 6px 10px;
              margin-top: 15px;
              border: 1px solid transparent;
              border-radius: 5px;
            "
            class="btn g-sure-btn"
            @click="determine()"
          >
            确定
          </button>
        </div>
      </div>
      <div
        class="success"
        style="
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
        "
        v-if="Sent == false"
      >
        <span
          style="width: 100%; height: 20%; border-bottom: 1px solid #cccccc"
        ></span>
        <span
          style="
            width: 100%;
            height: 60%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            margin-top: 30px;
          "
        >
          <p
            style="
              font-size: 32px;
              color: #00b4f4;
              line-height: 1.5;
              font-weight: bold;
            "
          >
            已下载成功
          </p>
          <div
            style="
              font-size: 18px;
              color: #999999;
              line-height: 1.5;
              font-weight: bold;
            "
          >
            请稍后查看您的邮箱
          </div>
        </span>
      </div>
    </vodal>
  </div>
</template>

<script>
import Title from "./Title.vue";
import { URLS, interact } from "fire-wind-water/index";
import Api from "@/service/api";
import IScroll from "iscroll";
import { tMixin } from "../../utils/i18n-t";
export default {
  components: {
    Title,
  },
  mixins: [tMixin],
  props: {
    seminarInfo: Object,
    memberInfo: Object,
    fileInfo: Object,
    extras: Object,
  },
  data() {
    return {
      listArr: [],
      Sent: true,
      mailbox: "",
      tip: "",
      show: false,
      num: 0,
      title: "资料下载",
      path: "",
      fileList: [],
      folderList: [],
      isSetting: 0,
      userInfo: {},
      currentId: "",
      currentDownloadType: "",
      isShowMore: false,
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.isSetting = 1;
    }
  },
  mounted() {
    const info = window.$sk.template.get();
    this.userInfo = info.user;
    this.mailbox = this.memberInfo.email || "";
    //this.initColumns();
    let tempColumns = this.getColumns.fileInitColumns(
      this.fileInfo.folderList,
      this.fileInfo.fileList,
      "大会资料"
    );
    this.folderList = tempColumns;
    if (this.folderList.length > 1) {
      this.$nextTick(() => {
        new IScroll(this.$refs.downLoadTab, {
          mouseWheel: false, // 鼠标滚轮控制
          scrollbars: false, //滚动条的显示
          scrollX: true,
          scrollY: false,
        });
      });
    }
    if (this.folderList.length > 0) {
      this.fileList = this.folderList[0].fileList;
      this.currentId = this.folderList[0].id;
      this.currentDownloadType = this.folderList[0].downloadType;
    }
  },
  methods: {
    initColumns() {
      let tempArticles = this.fileInfo.fileList;
      let tempColumns = this.fileInfo.folderList;
      const columns = [
        {
          id: 0,
          name: "大会资料",
          downloadType: 0,
          fileList: tempArticles,
        },
      ];
      for (let i in tempColumns) {
        columns.push(tempColumns[i]);
      }
      this.folderList = columns;
      if (this.folderList.length > 1) {
        this.$nextTick(() => {
          new IScroll(this.$refs.downLoadTab, {
            mouseWheel: false, // 鼠标滚轮控制
            scrollbars: false, //滚动条的显示
            scrollX: true,
            scrollY: false,
          });
        });
      }
      if (this.folderList.length > 0) {
        this.fileList = this.folderList[0].fileList;
        this.currentId = this.folderList[0].id;
        this.currentDownloadType = this.folderList[0].downloadType;
      }
    },
    columnClick(item) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.currentId = item.id;
      this.currentDownloadType = item.downloadType;
      this.fileList = item.fileList;
    },
    showMoreArticle() {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.isShowMore = !this.isShowMore;
    },
    handlePreview(previewUrl) {
      const url = window.location.href;
      let previewCode = "11291";
      switch (url) {
        case url.indexOf("://dev") >= 0:
          previewCode = "11291";
          break;
        case url.indexOf("://tf") >= 0:
          previewCode = "18077";
          break;
        case url.indexOf("://uf") >= 0:
        case url.indexOf("://uat") >= 0:
          previewCode = "14461";
          break;
        default:
          previewCode = "14460";
          break;
      }
      const protocolMatch = previewUrl.indexOf("https");
      let resultUrl = `http://ow365.cn/?i=${previewCode}&furl=${previewUrl}&type=download`;
      if (protocolMatch === 0) {
        resultUrl = `http://ow365.cn/?i=${previewCode}&ssl=1&furl=${previewUrl}&type=download`;
      }
      return resultUrl;
    },
    preview(file) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      const previewUrl = this.handlePreview(file.preview);
      window.$sk.goto(previewUrl, true).subscribe((url) => {
        window.open(url);
      });
      const { tenantId, weChatId } = this.seminarInfo;
      const userInfo = this.userInfo;
      Api.previewFile({
        browseInfo: interact.browseInfo,
        currentUrl: file.preview,
        fileId: file.id,
        globalUserId: userInfo.globalUserId,
        sess: userInfo.session,
        tenantId,
        weChatId,
        source: "PC",
      });
    },
    determine() {
      const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!reg.test(this.mailbox)) {
        this.tip = "请输入正确邮箱";
      } else {
        this.downloadEvent(this.mailbox, this.listArr);
      }
    },
    getForm(formId) {
      const param = {
        tenantId: this.seminarInfo.tenantId,
        memberFormId: formId,
        schemaId: this.seminarInfo.schemaId,
        formId: formId,
      };
      return Api.getFormNewRegister(param);
    },
    download(item) {
      const id = item.id;
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      if (this.currentDownloadType == 0) {
        //邮箱下载
        if (item.identity == 3 && item.registerFormId) {
          //需要登录
          const info = window.$sk.template.get();
          const smarketMember = info.cookie.getSession();
          this.isLogin = !!smarketMember;
          if (this.isLogin) {
            this.listArr = [id];
            this.show = true;
            this.Sent = true;
          } else {
            this.getForm(item.registerFormId).then((res) => {
              if (res.result == 0) {
                const loginUrl = URLS.updateSearchParam(
                  "backUrl",
                  encodeURIComponent(window.location.href),
                  res.content.originUrl.pc
                );
                window.$sk.goto(loginUrl);
              }
            });
          }
        } else {
          this.listArr = [id];
          this.show = true;
          this.Sent = true;
        }
      } else {
        //直接下载
        ///需要判断下载权限 要求登录就去模板页面
        if (item.identity == 3 && item.registerFormId) {
          //需要登录
          const info = window.$sk.template.get();
          const smarketMember = info.cookie.getSession();
          this.isLogin = !!smarketMember;
          if (this.isLogin) {
            window.$sk
              .goto(item.fileDownloadUrl + "&type=download", true)
              .subscribe((url) => {
                window.open(url);
              });
          } else {
            this.getForm(item.registerFormId).then((res) => {
              if (res.result == 0) {
                const loginUrl = URLS.updateSearchParam(
                  "backUrl",
                  encodeURIComponent(window.location.href),
                  res.content.originUrl.pc
                );
                window.$sk.goto(loginUrl);
              }
            });
          }
        } else {
          window.$sk
            .goto(item.fileDownloadUrl + "&type=download", true)
            .subscribe((url) => {
              window.open(url);
            });
        }
      }
    },
    downloadEvent(email, fileList) {
      const { instanceId } = this.seminarInfo;
      const info = window.$sk.template.get();
      const { globalUserId, session, openId } = info.user;
      Api.getDownloadWithEmail({
        instanceId,
        email,
        sess: session ? session : "",
        openId: openId ? openId : "",
        globalUserId,
        moduleType: 3,
        fileList,
      }).subscribe(() => {
        //ko item
        this.mailbox = "";
        // this.tip = item.desc;
        this.Sent = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 14px;
  border-bottom: 1px solid #e5e5e5;
  padding: 10px;
}
.mail {
  padding: 30px 50px;
  border-bottom: 1px solid #e5e5e5;
  input {
    padding: 5px;
    width: 300px;
    height: 40px;
    border: 1px solid #c2c2c2;
    box-sizing: border-box;
  }
  .tip {
    font-size: 12px;
    color: #ff0000;
  }
}
</style>
